/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QuotaUsage { 
    /**
     * The additional price per unit in cents.
     */
    additional_price: string;
    can_use_more: boolean;
    /**
     *  production_projects ProductionProjects staging_projects StagingProjects development_projects DevelopmentProjects daily_active_users DailyActiveUsers custom_domains CustomDomains event_streams EventStreams event_stream_events EventStreamEvents sla SLA collaborator_seats CollaboratorSeats edge_cache EdgeCache branding_themes BrandingThemes zendesk_support ZendeskSupport project_metrics ProjectMetrics project_metrics_time_window ProjectMetricsTimeWindow project_metrics_events_history ProjectMetricsEventsHistory organizations Organizations rop_grant ResourceOwnerPasswordGrant concierge_onboarding ConciergeOnboarding credit Credit data_location_global DataLocationGlobal data_location_us DataLocationUS data_location_asiane DataLocationAsiaNorthEast m2m_token_issuance M2MTokenIssuance permission_checks PermissionChecks captcha Captcha data_location_regional DataLocationRegional  Required Features rate_limit_tier RateLimitTier session_rate_limit_tier RateLimitTierSessions identities_list_rate_limit_tier RateLimitTierIdentitiesList permission_checks_rate_limit_tier RateLimitTierPermissionChecks oauth2_introspect_rate_limit_tier RateLimitTierOAuth2Introspect
     */
    feature: QuotaUsage.FeatureEnum;
    feature_available: boolean;
    included: number;
    is_unlimited: boolean;
    used: number;
}
export namespace QuotaUsage {
    export type FeatureEnum = 'production_projects' | 'staging_projects' | 'development_projects' | 'daily_active_users' | 'custom_domains' | 'event_streams' | 'event_stream_events' | 'sla' | 'collaborator_seats' | 'edge_cache' | 'branding_themes' | 'zendesk_support' | 'project_metrics' | 'project_metrics_time_window' | 'project_metrics_events_history' | 'organizations' | 'rop_grant' | 'concierge_onboarding' | 'credit' | 'data_location_global' | 'data_location_us' | 'data_location_asiane' | 'm2m_token_issuance' | 'permission_checks' | 'captcha' | 'data_location_regional' | 'rate_limit_tier' | 'session_rate_limit_tier' | 'identities_list_rate_limit_tier' | 'permission_checks_rate_limit_tier' | 'oauth2_introspect_rate_limit_tier';
    export const FeatureEnum = {
        ProductionProjects: 'production_projects' as FeatureEnum,
        StagingProjects: 'staging_projects' as FeatureEnum,
        DevelopmentProjects: 'development_projects' as FeatureEnum,
        DailyActiveUsers: 'daily_active_users' as FeatureEnum,
        CustomDomains: 'custom_domains' as FeatureEnum,
        EventStreams: 'event_streams' as FeatureEnum,
        EventStreamEvents: 'event_stream_events' as FeatureEnum,
        Sla: 'sla' as FeatureEnum,
        CollaboratorSeats: 'collaborator_seats' as FeatureEnum,
        EdgeCache: 'edge_cache' as FeatureEnum,
        BrandingThemes: 'branding_themes' as FeatureEnum,
        ZendeskSupport: 'zendesk_support' as FeatureEnum,
        ProjectMetrics: 'project_metrics' as FeatureEnum,
        ProjectMetricsTimeWindow: 'project_metrics_time_window' as FeatureEnum,
        ProjectMetricsEventsHistory: 'project_metrics_events_history' as FeatureEnum,
        Organizations: 'organizations' as FeatureEnum,
        RopGrant: 'rop_grant' as FeatureEnum,
        ConciergeOnboarding: 'concierge_onboarding' as FeatureEnum,
        Credit: 'credit' as FeatureEnum,
        DataLocationGlobal: 'data_location_global' as FeatureEnum,
        DataLocationUs: 'data_location_us' as FeatureEnum,
        DataLocationAsiane: 'data_location_asiane' as FeatureEnum,
        M2mTokenIssuance: 'm2m_token_issuance' as FeatureEnum,
        PermissionChecks: 'permission_checks' as FeatureEnum,
        Captcha: 'captcha' as FeatureEnum,
        DataLocationRegional: 'data_location_regional' as FeatureEnum,
        RateLimitTier: 'rate_limit_tier' as FeatureEnum,
        SessionRateLimitTier: 'session_rate_limit_tier' as FeatureEnum,
        IdentitiesListRateLimitTier: 'identities_list_rate_limit_tier' as FeatureEnum,
        PermissionChecksRateLimitTier: 'permission_checks_rate_limit_tier' as FeatureEnum,
        Oauth2IntrospectRateLimitTier: 'oauth2_introspect_rate_limit_tier' as FeatureEnum
    };
}


